"use client";
import { useState } from "react";
import PriceCalculator from "../components/PriceCalculator.jsx";

const PriceCalculatorUI = () => {
  const [showCalculator, setShowCalculator] = useState(false);

  return (
    <>
      <div id="price-calculator" className="fixed bottom-10 right-24 z-50">
        <button
          id="calculator-button"
          onClick={() => setShowCalculator(!showCalculator)}
          // className='w-24 h-24 rounded-full bg-gray-800 text-white flex items-center justify-center transition-colors duration-300 relative hover:[animation-play-state:paused] active:[animation-play-state:paused] '
          className={`w-24 h-24 rounded-full bg-black flex items-center justify-center shadow-2xl transition-colors duration-300 relative hover:animate-none`}
        >
          {/* SVG text around circle */}
          <svg
            viewBox="0 0 100 100"
            className="absolute inset-0 w-full h-full  transition-transform duration-300 animate-spin-slow hover:[animation-play-state:paused] active:[animation-play-state:paused]"
          >
            <defs>
              <path
                id="circlePath"
                d="M50,50 m-45,0 a45,45 0 1,1 90,0 a45,45 0 1,1 -90,0"
              />
            </defs>
            <text
              fill="white"
              fontSize="23"
              dy="16"
              fontWeight="bold"
              className="transition-transform duration-300 drop-shadow-md "
            >
              <textPath href="#circlePath" startOffset="0%">
                Price Calculator
              </textPath>
            </text>
          </svg>
        </button>

        {showCalculator && (
          <>
            <div className="fixed inset-0 bg-gray-200 bg-opacity-30 backdrop-blur-sm z-40">
              <div
                id="price-calculator-popup"
                className="fixed bottom-1/2 right-1/2 transform translate-x-1/2 translate-y-1/2 z-50 bg-gray-200 bg-opacity-80 backdrop-blur-md p-6 rounded-lg shadow-xl md:w-5/6 max-w-4xl max-h-[90vh] overflow-y-auto"
              >
                <PriceCalculator setShowCalculator={setShowCalculator} />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PriceCalculatorUI;
